import {
  getData,
  postData,
  getFileData,
  convertPageModel
} from './api-base.service';
import {
  QuestionnaireEx
} from "@/model/questionnaireEx";

export const getQuestionnairePageData = (model) => {
  let data = convertPageModel(model);
  return postData('/Questionnaire/GetQuestionnairePageData', data);
}

export const saveQuestionnaire = (data) => {
  return postData('/Questionnaire/SaveQuestionnaire', data);
}

export const deleteQuestionnaire = (id) => {
  let data = {
    id
  };
  return getData('/Questionnaire/DeleteQuestionnaire', data);
}

export const cloneQuestionnaire = (id, termId) => {
  let data = {
    id,
    termId
  };
  return getData('/Questionnaire/CloneQuestionnaire', data);
}

export const getQuestionnaireQuestionPageData = (model) => {
  let data = convertPageModel(model);
  return postData('/Questionnaire/GetQuestionnaireQuestionPageData', data);
}

export const saveQuestionnaireQuestion = (data) => {
  return postData('/Questionnaire/SaveQuestionnaireQuestion', data);
}

export const deleteQuestionnaireQuestion = (id) => {
  let data = {
    id
  };
  return getData('/Questionnaire/DeleteQuestionnaireQuestion', data);
}

export const checkHaveStudentRecords = (questionnaireId) => {
  let data = {
    questionnaireId
  };

  return getData('/Questionnaire/CheckHaveStudentRecords', data);
};

export const getStudentCoursesQuestionnaireStatus = (studentId) => {
  let data = {
    studentId
  };

  return getData('/Questionnaire/GetStudentCoursesQuestionnaireStatus', data);
};

export const getStudentActiveQuestionnaires = async (studentId, courseId, termId = null) => {
  let data = {
    studentId,
    courseId,
    termId
  };

  let result = await getData('/Questionnaire/GetStudentActiveQuestionnaires', data);
  if (!!result && result.success) {
    result.data.ActiveQuestionnaires = result.data.ActiveQuestionnaires.map(item => new QuestionnaireEx(item));
  }
  return result;
}

export const saveStudentQuestionnaireRecords = (data) => {
  return postData('/Questionnaire/SaveStudentQuestionnaireRecords', data);
}

export const exportStudentQuestionnaireRecords = (termId = null) => {
  let data = {
    termId
  };

  var result = getFileData('/Questionnaire/ExportStudentQuestionnaireRecords', data, true, true);
  return result;
}



// WEBPACK FOOTER //
// ./src/service/questionnaire.service.js